import {MdBugReport, MdReportProblem} from 'react-icons/md';

type Props = {
  opened: boolean;
  close: () => void;
  openReportModal: () => void;
  openDoubtModal: () => void;
};

export const CommentItemMoreMenu: React.FC<Props> = ({
  opened,
  close,
  openReportModal,
  openDoubtModal,
}) => {
  const onReportClick = () => {
    openReportModal();
    close();
  };

  const onDoubtClick = () => {
    openDoubtModal();
    close();
  };

  return (
    opened && (
      <>
        <div
          className="h-svh w-svw fixed top-0 left-0 bg-transparent z-50"
          onClick={close}
        />
        <div className="bg-white p-4 shadow-modal w-[190px] rounded-4 absolute bottom-[-85px] left-[-4px] z-50">
          <div className="border-b-[1px] border-line border-collapse">
            <button
              className="flex items-center text-base text-notification-1 leading px-12 w-full h-[38px] hover:opacity-8 "
              onClick={onReportClick}
            >
              <div className="mr-8">
                <MdReportProblem size={16} />
              </div>
              通報する
            </button>
          </div>
          <button
            className="flex items-center text-base text-black-2 leading px-12 w-full h-[38px] hover:opacity-8 "
            onClick={onDoubtClick}
          >
            <div className="mr-8">
              <MdBugReport size={16} />
            </div>
            本当に？
          </button>
        </div>
      </>
    )
  );
};
